import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../config';

const RegisterDe = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setMessage('Passwörter stimmen nicht überein.');
      return;
    }
    try {
      const response = await axios.post(`${BASE_URL}/api/register/`, {
        email,
        password,
      });
      setMessage(`Erfolgreich registriert: ${response.data.email}`);
      navigate('/login'); 
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const messages = Object.entries(data)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join(' | ');
        setMessage(`Registrierung fehlgeschlagen: ${messages}`);
      } else {
        setMessage('Registrierung fehlgeschlagen. Bitte versuche es erneut.');
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Konto erstellen</h2>
        <p className="auth-subtitle">Werde Teil von Vegbox</p>
        <div className="mb-3">
          <label className="auth-label">E-Mail</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="du@beispiel.de"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Passwort</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Passwort bestätigen</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onPaste={(e) => e.preventDefault()}
          />
          {confirmPassword && password !== confirmPassword && (
            <p style={{ color: '#e74c3c', fontSize: '0.82rem', marginTop: '4px' }}>Passwörter stimmen nicht überein.</p>
          )}
        </div>
        <div className="auth-links">
          <a href="/login">Bereits ein Konto? Anmelden</a>
        </div>
        <button className="auth-btn" onClick={handleRegister}>
          Konto erstellen
        </button>
        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
};

export default RegisterDe;
